// The two provider marks on the project card and in the connection panels: in colour
// when the user's account is connected, grey when it is not, with a small green check
// when THIS project is linked. Simplified drawings of the Autodesk and Procore marks,
// sized for a 34 px button.
import React from "react";

const GREY = "#B0B8BD";

function LinkedBadge() {
  return (
    <g>
      <circle cx="19.5" cy="19.5" r="4.5" fill="#12B76A" stroke="#fff" strokeWidth="1.5" />
      <path d="M17.6 19.6l1.3 1.3 2.5-2.6" fill="none" stroke="#fff" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    </g>
  );
}

/** Autodesk cloud: the Autodesk "A" mark on a cloud. */
export function AutodeskLogo({ connected = false, linked = false, size = 22, title }) {
  const cloud = connected ? "#0696D7" : GREY;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" role="img" aria-label={title || "Autodesk Construction Cloud"}>
      {title ? <title>{title}</title> : null}
      <path d="M18.2 19.5H6.6a5.1 5.1 0 0 1-.8-10.1A6.7 6.7 0 0 1 18.6 8a5.8 5.8 0 0 1-.4 11.5Z" fill={cloud} />
      {/* the Autodesk A: a long leaning stroke and the short crossbar foot */}
      <path d="M7.4 17.2 12.6 7.6h2.2l-5.1 9.6Z" fill="#fff" />
      <path d="M11.1 14.6h5.3l1.2 2.6h-2.3l-0.6-1.2h-4.2Z" fill="#fff" opacity="0.85" />
      {linked ? <LinkedBadge /> : null}
    </svg>
  );
}

/** Procore: the orange rounded tile with the white P. */
export function ProcoreLogo({ connected = false, linked = false, size = 22, title }) {
  const tile = connected ? "#FF5200" : GREY;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" role="img" aria-label={title || "Procore"}>
      {title ? <title>{title}</title> : null}
      <rect x="2" y="2" width="20" height="20" rx="5" fill={tile} />
      <path d="M8.2 6.5h4.6a3.9 3.9 0 0 1 0 7.8h-2.1v3.2H8.2Zm2.5 2.3v3.2h2a1.6 1.6 0 0 0 0-3.2Z" fill="#fff" fillRule="evenodd" />
      {linked ? <LinkedBadge /> : null}
    </svg>
  );
}
